import { render, staticRenderFns } from "./MovieDetails.vue?vue&type=template&id=1af64e6e&scoped=true"
import script from "./MovieDetails.vue?vue&type=script&lang=js"
export * from "./MovieDetails.vue?vue&type=script&lang=js"
import style0 from "./MovieDetails.vue?vue&type=style&index=0&id=1af64e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af64e6e",
  null
  
)

export default component.exports